import { type ReactNode } from 'react';

export function PopOutCell({ collapsed, expanded, minWidth }: { collapsed: ReactNode; expanded: ReactNode; minWidth?: number }) {
  return (
    <div className="relative" data-state="truncated">
      {collapsed}
      <div
        className="absolute top-0 left-0 -translate-x-3 -translate-y-3 z-10 p-3 rounded-lg outline outline-1 outline-dinnerplate-white bg-off-white w-max shadow-soft hidden group-hover/popout:block"
        style={{ minWidth }}
      >
        {expanded}
      </div>
    </div>
  );
}
